<template>
  <div class="main-footer d-flex justify-content-end" style="margin-left: 0px">
    <!-- <div>2013</div> -->
    <strong class="d-flex">Todo los derechos reservados &copy; <div class="mr-2" v-text="anio"></div></strong>
    <!-- <div class="float-right d-none d-sm-inline-block"><b>Version</b> 3.0</div> -->
  </div>
</template>


<script>
    
  export default {
    data(){
      return {
        anio : new Date().getFullYear()
      }
    }
    
  }
</script>
